<template>
  <div class="wrap">
    <div>
      <router-view />
    </div>
    <footer>
      <p class="copy">{{ $t('footer.copyright') }}</p>
    </footer>
  </div>
</template>

<script>

  import Language from 'views/components/language';
  import Logo from 'views/components/logo';
  import {mapGetters} from 'vuex';

	export default {
    title: 'Clean Layout',

    components: {
      Language,
      Logo
    },
    computed: {
      stickyHeader () {
        return this.$store.getters.stickyHeader;
      },
      floatingHeader () {
        return this.$store.getters.floatingHeader;
      },
      transparentTop () {
        return !this.openLayers && this.$store.getters.visualHeight > this.scrollTop + 85
      }
    },
    data() {
      return {

      }
    },
    methods: {
      isOpened (flag) {
        this.$emit('popoverOpened',this.isPopoverOpened)
      }
    }
  }
</script>

<style src="./style.scss" lang="scss" scoped></style>
